import { takeGraphScreenshot } from 'components/Graph/helpers/graphScreenshot';
import type { MutableRefObject, RefObject } from 'react';
import type { GraphRendererPlugin } from './GraphRendererPlugin';

export type GraphAppHandle = {
  generateBase64Screenshot: () => string;
};

export type GraphAppHandleRef = RefObject<GraphAppHandle | null>;

export const externalApi =
  (
    graphAppHandleRef?: MutableRefObject<GraphAppHandle | null>,
  ): GraphRendererPlugin =>
  (pluginInterface) => {
    if (!graphAppHandleRef) {
      return;
    }

    const generateBase64Screenshot = () => {
      pluginInterface.events.emit('beforeGenerateScreenshot');

      return takeGraphScreenshot(pluginInterface.app);
    };

    graphAppHandleRef.current = {
      generateBase64Screenshot,
    };

    pluginInterface.events.addListener('beforeUnmount', () => {
      graphAppHandleRef.current = null;
    });
  };
